export default __webpack_public_path__ + "static/media/trash_black.9082d788.svg";